import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring, useReducedMotion } from "framer-motion";

export const CustomCursor = () => {
  const reduced = useReducedMotion();
  const [enabled, setEnabled] = useState(false);
  const [mode, setMode] = useState("default"); // default | link | panel
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const gx = useSpring(x, { stiffness: 180, damping: 24, mass: 0.6 });
  const gy = useSpring(y, { stiffness: 180, damping: 24, mass: 0.6 });

  useEffect(() => {
    if (reduced || !window.matchMedia("(pointer: fine)").matches) return;
    setEnabled(true);
    document.body.classList.add("mm-cursor-on");
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const over = (e) => {
      if (e.target.closest("[data-cursor='panel']")) setMode("panel");
      else if (e.target.closest("a, button, input, textarea, select, [role='button']")) setMode("link");
      else setMode("default");
    };
    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mouseover", over, { passive: true });
    return () => {
      document.body.classList.remove("mm-cursor-on");
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, [reduced, x, y]);

  if (!enabled) return null;

  const size = mode === "panel" ? 72 : mode === "link" ? 48 : 34;

  return (
    <>
      <motion.div
        data-testid="custom-cursor-glow"
        style={{ x: gx, y: gy, translateX: "-50%", translateY: "-50%" }}
        className="fixed top-0 left-0 z-[95] pointer-events-none"
      >
        <motion.div
          animate={{ width: size, height: size, opacity: mode === "panel" ? 0.9 : 0.6 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="rounded-full border border-cyan-300/40 flex items-center justify-center"
          style={{ boxShadow: "0 0 28px rgba(0,229,255,0.25), inset 0 0 14px rgba(0,229,255,0.10)" }}
        >
          {mode === "panel" && (
            <span className="font-tech text-[8px] tracking-[0.2em] text-cyan-200/90">VIEW</span>
          )}
        </motion.div>
      </motion.div>
      <motion.div
        style={{ x, y, translateX: "-50%", translateY: "-50%" }}
        className="fixed top-0 left-0 z-[96] pointer-events-none w-1.5 h-1.5 rounded-full bg-white"
      />
    </>
  );
};
